var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 1.66797H5.00016C4.55814 1.66797 4.13421 1.84356 3.82165 2.15612C3.50909 2.46868 3.3335 2.89261 3.3335 3.33464V16.668C3.3335 17.11 3.50909 17.5339 3.82165 17.8465C4.13421 18.159 4.55814 18.3346 5.00016 18.3346H15.0002C15.4422 18.3346 15.8661 18.159 16.1787 17.8465C16.4912 17.5339 16.6668 17.11 16.6668 16.668V5.83464L12.5002 1.66797Z",
    stroke: "#90A1B9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 1.66797V5.0013C11.6665 5.44333 11.8421 5.86725 12.1547 6.17981C12.4672 6.49237 12.8911 6.66797 13.3332 6.66797H16.6665",
    stroke: "#90A1B9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33335 7.5H6.66669",
    stroke: "#90A1B9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 10.832H6.6665",
    stroke: "#90A1B9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 14.168H6.6665",
    stroke: "#90A1B9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.fce7febc9ded98619ffe69ff3e4aaf62.svg";
export { ForwardRef as ReactComponent };